import React, {useEffect, useState} from 'react';
import {VscBook} from "react-icons/vsc";
import {MdOutlineArrowCircleRight} from "react-icons/md";
import {Link, useOutletContext} from "react-router-dom";
import {getCourseChapters} from "../../services/CourseRepository";
import {useError} from "../../hooks/useError";
import {ChapterNavigationBar} from "../navigation/ChapterNavigationBar";
import {routes} from "../../utils/Routes";

export function CoursePanel() {

    const [courseContent, setCourseContent] = useState([])
    const [selectedModule, setSelectedModule] = useState(null)
    const [firstLink, setFirstLink] = useState(null);
    const {courseId} = useOutletContext()
    const {setErrorMessage} = useError()

    function getFirstLink(content) {
        if(content != null && content.length >=1 && content.chapters != null && content.chapters.length >= 2) {
            return routes.chapterPage(courseId, content[0].moduleName, content[0].chapters[1].moduleChapterName)
        }
        return "#";
    }

    useEffect(() => {
        if(courseId != null) {
            getCourseChapters(courseId, setErrorMessage).then(result => {
                setCourseContent(result)
                setSelectedModule(result[0])
                setFirstLink(getFirstLink(result));
            })
        }
    }, []);

    return (
        <div className={"row"}>

            <div className={"col"}>

                <div className={"d-flex"}>
                    <VscBook size={32} className={"me-2"}/>
                    <h4>Kurs</h4>

                </div>
                <p className={"text-justify p-0 m-0 mb-2"}>
                    Her finner du kurs i form av tekst, bilder, video og interaktive moduler. Prøv deg
                    gjerne på oppgaver underveis og få tilbakemeldinger på ditt nivå.
                    Dersom du sitter fast, kan du alltids spørre den integrerte Karakterboost
                    KI-hjelperen!
                </p>
                {
                    firstLink != null ? (
                        <Link to={firstLink}
                              className={"text-decoration-none btn btn-primary text-white"}>
                            <label>Gå til kurs</label>
                            <MdOutlineArrowCircleRight size={32} className={"ms-2"}/>
                        </Link>
                    ) : null
                }

            </div>
            <div className={"col"}>
                <ChapterNavigationBar courseId={courseId} courseContent={courseContent}/>
            </div>

        </div>
    );
}